import { createSlice } from "@reduxjs/toolkit";
import { editCouponsAPI } from "../../api/coupons";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const editCouponsSlice = createSlice({
  name: "editCoupons",
  initialState: data,
  reducers: {
   editCouponsSlice(state) {
      state.isLoading = true;
    },
   editCouponsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    editCouponsSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    editCouponsSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const editCouponsHandler: any = (id:any,data:any) => async (dispatch: any) => {
  try {
    dispatch(editCouponsAction.editCouponsSlice());
    const response: any = await editCouponsAPI(id,data);
    
    dispatch(editCouponsAction.editCouponsSliceSuccess(response));
  } catch (e: any) {
    dispatch(editCouponsAction.editCouponsSliceFailure(e?.response?.data));
  }
};
export default editCouponsSlice.reducer;
export const editCouponsAction = editCouponsSlice.actions;
